export default __webpack_public_path__ + "static/media/card.8571a587.svg";